export enum ConfigPaths {
  importPath = 'import',
  exportPath = 'export'
}
